export const ActionType = {
  SHOW: "@react-redux-modal-provider.show",
  HIDE: "@react-redux-modal-provider.hide",
  HIDE_ALL: "@react-redux-modal-provider.hide-all",
  REMOVE: "@react-redux-modal-provider.remove",
  REMOVE_BY_COMPONENT: "@react-redux-modal-provider.remove-by-component"
};

export const showModal = (component, props = {}) => {
  if (!component) {
    return undefined;
  }

  return {
    type: ActionType.SHOW,
    component,
    props
  };
};

export const hideModal = id => ({
  type: ActionType.HIDE,
  id
});

export const removeModal = id => ({
  type: ActionType.REMOVE,
  id
});

export const removeModalByComponent = component => ({
  type: ActionType.REMOVE_BY_COMPONENT,
  component
});

export const hideAllModals = () => ({
  type: ActionType.HIDE_ALL
});
